import {
  STORE_DEFAULT_SHIPPING_FORM_OPTION,
  STORE_SHIPPING_OPTION_TYPES,
} from '../constants/storeCheckout.constants';
import type {
  IStoreResponse,
  IUpdateStoreRequest,
  StoreShippingType,
} from '@/common/interfaces/store.interface';

export type StoreShippingFormOption = 'one-place' | 'direct';

export const mapStoreShippingFormOptionToShippingType = (
  shippingOption: StoreShippingFormOption
): StoreShippingType =>
  shippingOption === 'one-place'
    ? STORE_SHIPPING_OPTION_TYPES.BULK_SHIPPING
    : STORE_SHIPPING_OPTION_TYPES.INDIVIDUAL_SHIPPING;

export const mapShippingTypeToStoreShippingFormOption = (
  shippingType: string | null | undefined
): StoreShippingFormOption | '' => {
  if (shippingType === STORE_SHIPPING_OPTION_TYPES.BULK_SHIPPING) {
    return 'one-place';
  }

  if (shippingType === STORE_SHIPPING_OPTION_TYPES.INDIVIDUAL_SHIPPING) {
    return 'direct';
  }

  return '';
};

export const resolveStoreShippingOptionFromStore = (
  store: Pick<IStoreResponse, 'shipping_type' | 'is_individually_shipped'>
): StoreShippingFormOption | '' => {
  const shippingOptionFromType = mapShippingTypeToStoreShippingFormOption(store.shipping_type);

  if (shippingOptionFromType) {
    return shippingOptionFromType;
  }

  if (store.is_individually_shipped) {
    return 'direct';
  }

  return STORE_DEFAULT_SHIPPING_FORM_OPTION;
};

export const buildStoreShippingTypeUpdatePayload = (
  orderId: number,
  shippingOption: StoreShippingFormOption
): IUpdateStoreRequest => ({
  order_id: orderId,
  shipping_type: mapStoreShippingFormOptionToShippingType(shippingOption),
});
